import React, { Component } from "react";
class BoardManagementNote extends Component {
    constructor(props) {
        super(props);

        this.state = {
            topic: props.currentEvent.topic,
            startTime: props.currentEvent.startTime,
            members: props.currentEvent.members,
            id: props.currentEvent.id
        };
    }
    render() {
        return (
            <div className="oda-form-container">
                <div className="card-body mt-1">
                    <div className="FormRenk col-sm-12">
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>Toplantı Konusu:</label>
                                <input
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>Toplantı Saati:</label>
                                <input
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>Katılacak Üyeler:</label>
                                <input
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default BoardManagementNote;



// WEBPACK FOOTER //
// ./src/page/agenda/BoardManagementNote.js